// extracted by mini-css-extract-plugin
export default {"heading":"style_heading__CEJtm","legend":"style_legend__8rexo"};